export function initAccordions() {
const accordionToggles = document.querySelectorAll('[data-js="accordion-toggler"]');

accordionToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
        const target = document.getElementById(toggle.getAttribute("aria-controls"));
        // setTimeout(() => {
            const isExpanded = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", !isExpanded);
            target.setAttribute("aria-hidden", isExpanded ? "true" : "false");
            if(isExpanded){
                target.setAttribute("inert", "");
            } else {
                target.removeAttribute("inert");
            }

        // }, 50)
    });
});
}